import compact from 'lodash/compact';
import { failedIntegrationStatuses, getInvoiceQboInfo } from "../../business-logic/invoiceQboLogic";
import { invoiceIntegrationModel, invoiceModel } from "../../models";
import { Intent } from "../../infra/access-control";
export const invoiceSearchParam = 'invoice';
export const relationshipSearchParam = 'relationship';
export const terminatedTooltip = 'The agreement is terminated';
export function getFooter(relationship, invoice) {
  const {
    paymentMethod,
    feeControls
  } = relationship;
  return compact([paymentMethod && invoiceModel.isPending(invoice) && {
    id: 'due',
    text: "The payment will be processed automatically on ".concat(invoiceModel.dueDate(invoice), " using a ").concat((paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) === 'creditCard' ? 'credit card' : 'bank account', " ending in ").concat(paymentMethod.last4, ".")
  }, !feeControls.coverCreditCardFees && (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) === 'creditCard' && {
    id: 'cc',
    text: 'Payments made with a credit card are subject to processing fees.'
  }]);
}
export function getServiceAndActiveBillCommands(serviceAndBillCommands) {
  return serviceAndBillCommands.map(_ref => {
    let {
      service,
      billCommands
    } = _ref;
    return {
      service,
      billCommands: billCommands.filter(c => c.status === 'active')
    };
  }).filter(_ref2 => {
    let {
      billCommands
    } = _ref2;
    return billCommands.length > 0;
  });
}
export function getURLWithFullPageInvoice(config) {
  const {
    invoiceId,
    relationshipId,
    pathname,
    search
  } = config;
  const url = new URL(pathname || location.pathname, location.origin);
  const searchParams = new URLSearchParams(search || location.search);
  searchParams.forEach((value, key) => url.searchParams.append(key, value));
  url.searchParams.set(invoiceSearchParam, invoiceId);
  url.searchParams.set(relationshipSearchParam, relationshipId);
  return url.pathname + url.search;
}
export function getCalloutInfo(integration) {
  if (!integration) {
    return null;
  }

  if (failedIntegrationStatuses.has(integration.status)) {
    // We can retry sync here.
    return {
      id: 'sync-after-failure',
      intent: 'warning',
      text: getInvoiceQboInfo(integration)
    };
  }

  if (integration.status === invoiceIntegrationModel.Status.PendingSync) {
    const {
      customerLinked,
      itemsLinked
    } = integration;

    if (!customerLinked || !itemsLinked) {
      return {
        id: 'requires-mapping',
        intent: 'warning',
        text: 'Invoice will be synced only after contact and services mapping with QuickBooks Online is completed.'
      };
    }

    return {
      id: 'ready-to-sync',
      intent: 'info',
      text: 'Invoice is ready to sync with QuickBooks Online.'
    };
  }

  return null;
}
export function makeStopPaymentInvoiceAction(isTerminatedRelationship) {
  return {
    text: 'Stop Payment',
    intent: Intent.InvoiceStopPayment,
    disabled: isTerminatedRelationship,
    tooltipTitle: isTerminatedRelationship ? terminatedTooltip : undefined
  };
}
export function makeResumePaymentInvoiceAction(isTerminatedRelationship) {
  return {
    text: 'Resume Payment',
    intent: Intent.InvoiceResumePayment,
    disabled: isTerminatedRelationship,
    tooltipTitle: isTerminatedRelationship ? terminatedTooltip : undefined
  };
}